import Header from '../../../../components/Header';
import UseInvoiceDetails from '../hooks/useInvoiceDetails';
import PageLoader from '../../../../../component/PageLoader';
import CustomUpdateStatusModel from '../../../components/customUpdateStatusModel';
import InvoicePdfView from './InvoicePdfView';
import InvoiceTableTabs from './InvoiceTableTabs';
import InvoiceVoidModel from './InvoiceVoidModel';
import RecordPaymentModel from './recordPaymentModel';
import { toast } from 'react-toastify';
import InvoiceShareLinkModal from './shareLink/InvoiceShareLinkModal';
import { getDate } from '../../../../../utils/dateUtils';
import CustomDrawer from '../../../components/customDrawer';
import { useState } from 'react';
import ProductDetailsDrawer from '../../../../components/ProductDetailsDrawer';
import { hasPermission } from '../../../../../utils/controller';

const InvoiceDetails = () => {
	const {
		user,
		id,
		suburl,
		loader,
		invoiceDetails,
		generateSalesInvoicesPdf,
		setUpdateStatus,
		setUpdateStatusModelOpen,
		isUpdateStatusModelOpen,
		handleUpdateStatus,
		navigate,
		handleVoidStatus,
		setIsVoidStatusModelOpen,
		isVoidStatusModelOpen,
		isShareLinkModelOpen,
		setShareLinkModelOpen,
		isRecordPaymentModalOpen,
		setIsRecordPaymentModalOpen,
		getInvoiceDetails,
	} = UseInvoiceDetails();

	const [drawerType, setDrawerType] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	return (
		<div style={{ backgroundColor: '#EDEDF7', height: '100%', overflowY: 'auto' }}>
			<div
				style={{
					position: 'sticky',
					top: 0,
					zIndex: 30,
					backgroundColor: '#EDEDF7',
					boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
				}}
			>
				<Header
					headerTitle="Invoices Details"
					closeButton={{
						showCloseButton: true,
						handler: () => navigate(`/user/${suburl}/invoices`),
					}}
					buttons={[
						invoiceDetails &&
							!['Draft', 'Void', 'Write off'].includes(invoiceDetails?.status) &&
							Number(invoiceDetails.due_amount) > 0 && {
								className: 'btn-gray mt-0 px-4 ',
								button: 'Record Payment',
								disabled: !hasPermission(
									'sales.payments_received.create',
									user?.role?.role_permissions,
								),
								handler: () => setIsRecordPaymentModalOpen(true),
								isDropdown: false,
							},
						invoiceDetails &&
							invoiceDetails?.status === 'Draft' && {
								className: 'btn-gray mt-0 px-4 ',
								button: 'Save Draft',
								isDropdown: false,
								disabled: !hasPermission('sales.invoices.create', user?.role?.role_permissions),
								handler: () => {
									setUpdateStatus('save');
									setUpdateStatusModelOpen(true);
								},
							},

						invoiceDetails && {
							title: 'Share',
							isDropdown: true,
							options: [
								...(hasPermission(
									'sales.invoices.communications_email',
									user?.role?.role_permissions,
								)
									? [
											{
												id: '1.1',
												handler: () => navigate(`/user/${suburl}/invoice-send-emails/${id}`),
												title: 'Send Email',
											},
										]
									: []),
								{
									id: '1.2',
									handler: () => setShareLinkModelOpen(true),
									title: 'Share Link',
								},
								{
									id: '1.3',
									handler: () => generateSalesInvoicesPdf('print', false),
									title: 'Print Pdf',
									disabled: !hasPermission(
										'sales.invoices.download_print_pdf',
										user?.role?.role_permissions,
									),
								},
								{
									id: '1.4',
									handler: () => generateSalesInvoicesPdf('download', false),
									title: 'Download Pdf',
									disabled: !hasPermission(
										'sales.invoices.download_print_pdf',
										user?.role?.role_permissions,
									),
								},
							],
						},

						invoiceDetails &&
							!['Draft', 'Void', 'Write off'].includes(invoiceDetails.status) && {
								title: 'Update Status',
								isDropdown: true,
								options: [
									{
										id: '3.1',
										title: 'Mark as Sent',
										disabled: !hasPermission(
											'sales.invoices.mark_as_sent',
											user?.role?.role_permissions,
										),
										handler: () => {
											if (invoiceDetails.is_mark_as_sent) {
												toast.error('This invoice has already been marked as sent');
											} else {
												setUpdateStatus('is_mark_as_sent');
												setUpdateStatusModelOpen(true);
											}
										},
									},
									...(!['Partially Paid', 'Paid'].includes(invoiceDetails.status)
										? [
												{
													id: '3.2',
													title: 'Void',
													disabled: !hasPermission(
														'sales.invoices.void',
														user?.role?.role_permissions,
													),
													handler: () => setIsVoidStatusModelOpen(true),
												},
											]
										: []),
									...(!['Write off', 'Paid'].includes(invoiceDetails.status)
										? [
												{
													id: '3.3',
													title: 'Write off',
													disabled: !hasPermission(
														'sales.invoices.write_off',
														user?.role?.role_permissions,
													),
													handler: () => {
														setUpdateStatus('is_write_off');
														setUpdateStatusModelOpen(true);
													},
												},
											]
										: []),
								],
							},

						/* ------------------------- 2) Reminders ------------------------ */
						invoiceDetails &&
							!['Draft', 'Void', 'Write off'].includes(invoiceDetails.status) && {
								title: 'Reminders',
								isDropdown: true,
								options: [
									{
										id: '2.1',
										title: 'Send Now',
										disabled: !hasPermission(
											'sales.invoices.communications_email',
											user?.role?.role_permissions,
										),
										handler: () => navigate(`/user/${suburl}/invoice-send-emails/${id}`),
									},
									{
										id: '2.2',
										title: 'Manage',
										handler: () => {},
									},
								],
							},

						/* ------------------------ 3) More Actions ---------------------- */
						invoiceDetails &&
							!['Void', 'Write off'].includes(invoiceDetails.status) && {
								title: 'More Actions',
								isDropdown: true,
								options: [
									...(!['Partially Paid', 'Paid'].includes(invoiceDetails.status)
										? [
												{
													id: '4.1',
													title: 'Edit',
													disabled: !hasPermission(
														'sales.invoices.edit',
														user?.role?.role_permissions,
													),
													handler: () => navigate(`/user/${suburl}/invoices-create/${id}`),
												},
											]
										: []),

									...(invoiceDetails.status !== 'Draft'
										? [
												{
													id: '4.2',
													title: 'Sale Return',
													disabled: !hasPermission(
														'sales.sales_return.create',
														user?.role?.role_permissions,
													),
													handler: () =>
														navigate(`/user/${suburl}/sales-return-create`, {
															state: { invoice: invoiceDetails },
														}),
												},
											]
										: []),
									...(invoiceDetails.status !== 'Draft'
										? [
												{
													id: '4.3',
													title: 'Clone',
													disabled:
														true ||
														!hasPermission('sales.invoices.clone', user?.role?.role_permissions),
													handler: () =>
														navigate(`/user/${suburl}/invoices-create/id=${id}&clone=true`),
												},
											]
										: []),

									// {
									// 	id: '4.4',
									// 	title: 'Delete',
									// 	handler: () => {},
									// },
								],
							},
					].filter(Boolean)}
					dropDownButtons={[]}
				/>
				<InvoiceTableTabs
					invoiceDetails={invoiceDetails}
					paymentsReceiveList={
						invoiceDetails?.payment_receives?.length > 0
							? invoiceDetails?.payment_receives.map((pr) => {
									return {
										id: pr?.payment_receive?.id,
										DATE: getDate(pr?.payment_receive?.date),
										'CUSTOMER NAME': pr?.payment_receive?.customer?.name,
										'PAYMENT MODE': pr?.payment_receive?.payment_mode?.payment_method_name,
										AMOUNT: pr?.invoice_payment_amount || 0,
									};
								})
							: []
					}
					salesReturnList={
						invoiceDetails?.returns?.length > 0
							? invoiceDetails?.returns?.map((ele) => {
									return {
										id: ele?.return?.id,
										DATE: getDate(ele?.return?.date),
										'SALE RETURN #': ele?.return?.return_number,
										'CUSTOMER NAME': ele.return?.customer?.name || 'N/A',
										STATUS: ele?.return?.status || 'N/A',
										'RECEIVED STATUS': ele?.return?.received_status || 'N/A',
										'REFUND MODE': ele?.return?.payment_mode?.payment_method_name || 'N/A',
										AMOUNT: ele?.return?.bill_total || 'N/A',
									};
								})
							: []
					}
					creditNoteList={
						invoiceDetails?.credit_note?.length > 0
							? invoiceDetails?.credit_note?.map((ele) => {
									return {
										id: ele.credit_note_id,
										DATE: getDate(ele?.credit_note?.date),
										'CREDIT NOTE #': ele?.credit_note?.credit_note_number || 'N/A',
										'CUSTOMER NAME': invoiceDetails.customer?.name || 'N/A',
										STATUS: ele?.credit_note?.status,
										TYPE:
											ele?.credit_note?.credit_note_type === 1
												? 'Damaged/Return Goods'
												: ele?.credit_note?.credit_note_type === 2
													? 'Excess Payment'
													: 'Advance Payment',
										AMOUNT: Number(ele?.credit_note?.total_credit_amount).toFixed(2),
									};
								})
							: []
					}
					CreditNoteApplied={
						invoiceDetails?.applied_credit_notes_transactions?.length > 0
							? invoiceDetails?.applied_credit_notes_transactions?.map((ele) => {
									return {
										id: ele.credit_note_id,
										DATE: getDate(ele?.created_at),
										'CREDIT NOTE #': ele?.credit_note?.credit_note_number || 'N/A',
										'APPLIED AMOUNT': Number(ele?.total_applied_amount).toFixed(2),
									};
								})
							: []
					}
				/>
			</div>
			{loader.isLoading && loader.status === 'detail' ? (
				<PageLoader />
			) : (
				<div>
					<InvoicePdfView
						invoiceDetails={invoiceDetails}
						setDrawerType={setDrawerType}
						setIsDrawerOpen={setIsDrawerOpen}
					/>
				</div>
			)}
			{isUpdateStatusModelOpen && (
				<CustomUpdateStatusModel
					updateStatusModel={isUpdateStatusModelOpen}
					setUpdateStatusModel={setUpdateStatusModelOpen}
					statusText={'Are you sure you want to change update status of Invoice?'}
					handleUpdateStatus={handleUpdateStatus}
				/>
			)}
			{isShareLinkModelOpen && (
				<InvoiceShareLinkModal
					invoiceId={id}
					isShareLinkModelOpen={isShareLinkModelOpen}
					setShareLinkModelOpen={setShareLinkModelOpen}
				/>
			)}
			{isVoidStatusModelOpen && (
				<InvoiceVoidModel
					updateStatusModel={isVoidStatusModelOpen}
					setUpdateStatusModel={setIsVoidStatusModelOpen}
					handleUpdateStatus={(status) => handleVoidStatus(status)}
				/>
			)}
			{isRecordPaymentModalOpen && (
				<RecordPaymentModel
					invoiceDetails={invoiceDetails}
					isRecordPaymentModalOpen={isRecordPaymentModalOpen}
					setIsRecordPaymentModalOpen={setIsRecordPaymentModalOpen}
					getInvoiceDetails={getInvoiceDetails}
				/>
			)}
			{isSidebarOpen && (
				<ProductDetailsDrawer
					id={invoiceDetails?.product_id}
					vendor={{
						vendor_id: invoiceDetails?.vendor?.vendor_id,
						vendor_name: invoiceDetails?.vendor?.vendor_name,
					}}
					setIsSidebarOpen={setIsSidebarOpen}
				/>
			)}
			{
				<CustomDrawer
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={drawerType === 'customer' ? invoiceDetails.customer_id : null}
					drawerType={drawerType}
					activeDrawer={'Details'}
				/>
			}
		</div>
	);
};
export default InvoiceDetails;
